

export const FETCHED_USERS_TRACKS  = 'FETCHED_USERS_TRACKS';
export const FETCHED_USERS_TRACKS_BY_PAGE  = 'FETCHED_USERS_TRACKS_BY_PAGE';
export const REQUESTED_USERS_TRACKS = 'REQUESTED_USERS_TRACKS';
export const REQUESTED_USERS_TRACKS_SUCCEED = 'REQUESTED_USERS_TRACKS_SUCCEED';
export const REQUESTED_USERS_TRACKS_FAILED = 'REQUESTED_USERS_TRACKS_FAILED';
export const RESET_USERS_TRACKS = 'RESET_USERS_TRACKS';

export const FETCHED_USERS_LIKED_TRACKS  = 'FETCHED_USERS_LIKED_TRACKS';
export const FETCHED_USERS_LIKED_TRACKS_BY_PAGE  = 'FETCHED_USERS_LIKED_TRACKS_BY_PAGE';
export const REQUESTED_USERS_LIKED_TRACKS = 'REQUESTED_USERS_LIKED_TRACKS';
export const REQUESTED_USERS_LIKED_TRACKS_SUCCEED = 'REQUESTED_USERS_LIKED_TRACKS_SUCCEED';
export const REQUESTED_USERS_LIKED_TRACKS_FAILED = 'REQUESTED_USERS_LIKED_TRACKS_FAILED';
export const RESET_LIKED_TRACKS = 'RESET_LIKED_TRACKS';

export const FETCHED_USER = 'FETCHED_USER';
export const REQUESTED_USER = 'REQUESTED_USER';
export const REQUESTED_USER_SUCCEED = 'REQUESTED_USER_SUCCEED';
export const REQUESTED_USER_FAILED = 'REQUESTED_USER_FAILED';